export default __webpack_public_path__ + "static/media/NIAS0470.34I-34796_-25722_0.548a5aa4.jpg";